import React from 'react';
import styled from 'styled-components';

export const NotificationIcon = styled.div`
  && {
    border-right: 1px solid white;
    padding: 5px 20px 5px 0;
    margin-right: 20px
  }
`;